import React, { FC } from 'react'
import ArrowIcon from '../../images/arrow-icon.svg'

interface Props {
  link: string
  icon: string
  text: string
}

const SocialLink: FC<Props> = ({ link, icon, text }) => {
  return (
    <div className="row">
      <div className="col-12">
        <div className="social-link-wrap bg-white py-3 px-4">
          <a
            href={link}
            className="social-link-inner d-flex text-secondary align-items-center text-decoration-none"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="social-link-icon mr-2">
              <i className={`icon-${icon}`}></i>
            </span>
            <span className="social-link-text flex-grow-1">{text}</span>
            <img src={ArrowIcon} alt="Arrow icon" aria-hidden={true} />
          </a>
        </div>
      </div>
    </div>
  )
}

export default SocialLink
